// extracted by mini-css-extract-plugin
module.exports = {"notification_row":"NotificationRow_notification_row__3ZQYw","notification_name":"NotificationRow_notification_name__DwDbN"};